import { Competition } from "../types/competition";

// 示例比赛数据 - 可以从 API 或数据库动态加载
export const competitions: Competition[] = [
  {
    id: "match-001",
    name: "2024 春季联赛 - 第一轮",
    date: "2024-03-15",
    location: "主场体育馆",
    teams: [
      { name: "蓝队", score: 3 },
      { name: "红队", score: 2 },
    ],
    highlights: ["精彩进球", "绝杀时刻"],
    theme: {
      primaryColor: "#3B82F6",
      secondaryColor: "#EF4444",
      backgroundColor: "#1F2937",
    },
  },
  {
    id: "match-002",
    name: "2024 春季联赛 - 第二轮",
    date: "2024-03-22",
    location: "客场体育馆",
    teams: [
      { name: "绿队", score: 1 },
      { name: "黄队", score: 1 },
    ],
    theme: {
      primaryColor: "#10B981",
      secondaryColor: "#F59E0B",
      backgroundColor: "#111827",
    },
  },
  {
    id: "match-003",
    name: "2024 春季联赛 - 决赛",
    date: "2024-04-10",
    location: "总决赛场馆",
    teams: [
      { name: "蓝队", score: 4 },
      { name: "绿队", score: 2 },
    ],
    highlights: ["帽子戏法", "门线救险", "点球大战"],
    theme: {
      primaryColor: "#8B5CF6",
      secondaryColor: "#EC4899",
      backgroundColor: "#0F172A",
    },
  },
];

// 动态获取比赛数据的工厂函数
export function getCompetitions(): Competition[] {
  // 这里可以替换为 API 调用或数据库查询
  return competitions;
}

// 按 ID 获取单个比赛
export function getCompetitionById(id: string): Competition | undefined {
  return competitions.find((c) => c.id === id);
}
